module.exports = __webpack_public_path__ + "img/signal-weak.d934ec95.svg";